import axios from "axios";
import { Message } from "element-ui";
import { tansParams } from "@/utils/common";

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 15000,
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    if (config.method === "get" && config.params) {
      let url = config.url + "?" + tansParams(config.params);
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 二进制数据则直接返回
    if (
      res.request.responseType === "blob" ||
      res.request.responseType === "arraybuffer"
    ) {
      return res.data;
    }
    if (code == 200) {
      return res.data;
    } else if (code == 500) {
      Message({
        message: res.data.msg || "系统未知错误，请反馈给管理员",
        type: "error",
        duration: 5 * 1000,
      });
      return Promise.reject("error");
    } else {
      Message({
        message: res.data.msg || "系统未知错误，请反馈给管理员",
        type: "error",
        duration: 5 * 1000,
      });
      return Promise.reject("error");
    }
  },
  (error) => {
    console.log("err" + error);
    let { message } = error;
    if (message === "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({ message: message, type: "error", duration: 5 * 1000 });
    return Promise.reject(error);
  }
);

export default service;
